import React from 'react';
import { Anchor, Button, Chip, PanelHeader, colourString } from '@keplerco/core';
import { CompletionStatus } from '../../../../../enums';
import styles from './confirm-peer-ratings-modal.module.css';
import { ConfirmPeerRatingsModalLayoutProps, RenderCardProps } from './confirm-peer-ratings-modal.models';
import classNames from 'classnames';

function RenderCard({ label, customTheme, count, buttonText, handleClick }: RenderCardProps) {
  return (
    <div className={classNames('card', styles.card)}>
      <Chip customTheme={customTheme}>{label}</Chip>
      <h2 style={{ margin: '20px 0 10px' }}>{count}</h2>
      <span style={{ marginBottom: '20px', color: colourString('accent-2') }}>{count === 1 ? 'Team Member' : 'Team members'}</span>
      <Anchor onClick={handleClick}>{buttonText}</Anchor>
    </div>
  );
}

export function ConfirmPeerRatingsModalLayout({ team, title, handleShowCompleted, handleShowNotCompleted, onClickSubmit }: ConfirmPeerRatingsModalLayoutProps): JSX.Element {
  const usersNotCompletedReview = team?.filter(i => !i.hasCompletedReview && i.completionStatus !== CompletionStatus.NoActionRequired).length ?? 0;
  const usersCompletedReview = team?.filter(i => i.hasCompletedReview).length ?? 0;

  return (
    <div className="modalContent" style={{ display: 'flex', flexDirection: 'column', gap: 30 }}>
      <PanelHeader title={title} />

      <div className={styles.cards}>
        {usersNotCompletedReview > 0 && (
          <RenderCard label="Not Started" customTheme={{ backgroundColor: 'background', borderColor: 'baby-blue', color: 'text' }} count={usersNotCompletedReview} buttonText={usersNotCompletedReview === 1 ? 'Finish Endorsement' : 'Finish Endorsements'} handleClick={handleShowNotCompleted} />
        )}

        <RenderCard label="Completed" customTheme={{ backgroundColor: 'g_2', borderColor: 'g_1', color: 'text' }} count={usersCompletedReview} buttonText={usersCompletedReview === 1 ? 'Change Endorsement' : 'Change Endorsements'} handleClick={handleShowCompleted} />
      </div>

      <div style={{ textAlign: 'center' }}>
        <Button type="button" filled onClick={onClickSubmit}>
          Yes, I'm done
        </Button>
      </div>
    </div>
  );
}
